import {makeAutoObservable, observable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";

export interface IEndSeasonController extends ViewController {
	readonly i18n: ILocalizationStore;

	get isSecretPassed(): boolean;

	setCount: () => void;
}

@injectable()
export class EndSeasonController implements IEndSeasonController {
	@observable private _count: number = 0;

	get isSecretPassed() {
		return this._count >= 10;
	}
	constructor(@inject(Bindings.LocalizationStore) readonly i18n: ILocalizationStore) {
		makeAutoObservable(this);
	}

	setCount = () => {
		this._count += 1;
	};
}
